import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, fileUrl } from "@/lib/api";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";
import { Badge } from "@/components/ui/badge";
import { Seo } from "@/components/Seo";
import { ArrowRight, Newspaper } from "lucide-react";

export default function BlogList() {
  const [articles, setArticles] = useState([]);
  const [cats, setCats] = useState([]);
  const [active, setActive] = useState("");

  useEffect(() => {
    api.get("/articles/categories").then((r) => setCats(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    const q = active ? `?category=${encodeURIComponent(active)}` : "";
    api.get(`/articles${q}`).then((r) => setArticles(r.data)).catch(() => {});
  }, [active]);

  return (
    <div className="min-h-screen bg-background">
      <Seo
        path="/blog"
        title="Blog Travele — Panduan, Tips & Informasi Rute Travel Indonesia"
        description="Panduan rute, tips perjalanan, harga travel, dan informasi kota di seluruh Indonesia dari Travele."
      />
      <Navbar />
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6">
        <p className="flex items-center gap-2 font-mono-terminal text-xs uppercase tracking-widest text-primary">
          <Newspaper className="h-3.5 w-3.5" /> Blog & Artikel
        </p>
        <h1 className="mt-2 font-display text-3xl font-black uppercase tracking-tighter sm:text-4xl lg:text-5xl">Artikel Perjalanan</h1>
        <p className="mt-2 max-w-2xl text-muted-foreground">Panduan rute, tips perjalanan, harga travel, dan informasi kota di seluruh Indonesia.</p>

        <div className="mt-6 flex flex-wrap gap-2">
          <button data-testid="blog-cat-all" onClick={() => setActive("")} className={`rounded-full px-4 py-1.5 text-sm font-semibold transition-colors ${active === "" ? "bg-primary text-primary-foreground" : "bg-secondary text-muted-foreground hover:text-foreground"}`}>Semua</button>
          {cats.map((c) => (
            <button key={c} data-testid={`blog-cat-${c}`} onClick={() => setActive(c)} className={`rounded-full px-4 py-1.5 text-sm font-semibold transition-colors ${active === c ? "bg-primary text-primary-foreground" : "bg-secondary text-muted-foreground hover:text-foreground"}`}>{c}</button>
          ))}
        </div>

        <div className="mt-8 grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {articles.map((a) => (
            <Link key={a.slug} to={`/blog/${a.slug}`} data-testid={`blog-card-${a.slug}`} className="group flex flex-col border border-border bg-card transition-colors hover:border-primary">
              <div className="flex aspect-[16/9] items-center justify-center overflow-hidden bg-secondary">
                {a.cover_image ? (
                  <img src={fileUrl(a.cover_image)} alt={a.title} loading="lazy" className="h-full w-full object-cover" />
                ) : (
                  <Newspaper className="h-10 w-10 text-muted-foreground" />
                )}
              </div>
              <div className="flex flex-1 flex-col p-5">
                <Badge className="mb-2 w-fit bg-primary/15 text-primary hover:bg-primary/15">{a.category}</Badge>
                <h2 className="font-display text-lg font-bold leading-tight">{a.title}</h2>
                <p className="mt-2 flex-1 text-sm text-muted-foreground">{a.excerpt}</p>
                <span className="mt-3 flex items-center gap-1 text-sm font-semibold text-primary">Baca <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" /></span>
              </div>
            </Link>
          ))}
          {articles.length === 0 && <p className="text-muted-foreground">Belum ada artikel.</p>}
        </div>
      </div>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}
